<div
  mxc-form-control
  size="md"
  class="mxc-mb-2"
  [status]="selectFormControl?.dirty && selectFormControl?.invalid ? 'error' : 'neutral'"
>
  <label mxc-label required id="access_type">Access type</label>
  <div mxc-hstack spacing="$4">
    <mxc-combobox
      ariaLabelledby="access_type"
      [status]="selectFormControl?.dirty && selectFormControl?.invalid ? 'error' : 'neutral'"
      [isRequired]="true"
      [isDisabled]="options.length === 0"
      [isMultiple]="isMultiple"
      (onChange)="handleAccessChange($event); selectFormControl.markAsDirty()"
      [value]="selectFormControl.value"
    >
      <mxc-combobox-option *ngFor="let option of options" [value]="option.value" [label]="option.text">
        {{ option.text }}
      </mxc-combobox-option>
    </mxc-combobox>
    <div *ngIf="options.length === 0" class="mxc-self-center">
      <div mxc-spinner size="sm" role="progressbar" aria-label="Progress spinner"></div>
    </div>
  </div>

  <ng-container *ngIf="showError">
    <span mxc-error-text *mxcFormControlError>
      <span *ngIf="selectFormControl.hasError('required')">Access type is required</span>
    </span>
  </ng-container>
</div>
